<template>
  <div class="stage-results">
    <loader v-if="isApplyFilter"></loader>
    <loader v-if="!isLoaded && !isApplyFilter" class="table-loader"></loader>

    <div class="row mb-2">
      <div class="col-12 pl-1"
           v-if="(lastSession.length  && isLoaded && (isBCBA || isCurator)) || teachingMethod == 9">
        <mdc-radio :label="'protocol.last_session' | trans" name="mode"
                   v-model="mode" value="session"/>
        <mdc-radio :label="'protocol.detailed_result' | trans" name="mode"
                   v-model="mode" value="detail"/>
      </div>
    </div>

    <div class="row" v-if="!lastSession.length && teachingMethod != 9">
      <div class="col-12">
        <div class="text-center"
             v-if="(isEmptyMeasurements || isEmptyMeasurementsList || (protocol.isDtt && measurements.length < 2 && mode == 'session')) && isLoaded">
          <h5>{{'protocol.no_data' | trans }}</h5>
        </div>
      </div>
    </div>

    <div class="row"  v-if="mode == 'session' && lastSession.length">
      <div class="col-12">
        <h4 class="stage-results__title">
          {{'protocol.result_last_assigned_session' | trans}}
          {{'protocol.of_protocol' | trans}} "{{protocolData.protocol.title}}"</h4>
      </div>

      <div class="col-12">
        <div class="text-center mt-4"
             v-if="!lastSession.length && isLoaded">
          <h5>{{'protocol.no_data' | trans }}</h5>
        </div>
      </div>

      <div class="col-12" v-if="teachingMethod != 7 && teachingMethod != 8 && teachingMethod != 9 && teachingMethod != 10">

        <div class="row"  v-for="(session,index) in lastSession">

            <last-session-results
              :session="session"
              :rowStimuli="isUSD || isDTT ? session.phases : [session]"
            />
  
          <div class="col-12"  v-if="isShaping && lastSessionChart[index].data && lastSessionChart[index].yLabels">
              <line-shaping-chart class="row mt-2" v-bind:datasets="fetchDatasetForShapingChart(lastSessionChart[index].data)"
                                  key="shapingChart"
                                  chart-id="shapingChart"
                                  :xAxisLabel="'protocol.probe_by_session' | trans"
                                  v-bind:y-labels="lastSessionChart[index].yLabels"
                                  :list-chart-date="lastSessionChart[index].xLabels"
                                  v-bind:show-legend="false"
                                  :all-axis-show="true"
                                  v-bind:y-axes-begin-at-zero="true"
                                  :height="680"
                                  :width=null
                                  :aspect-ratio=false
              />
              <h4 class="chart__title mb-3">{{'protocol.shaping_last_session_chart' | trans}}</h4>
            </div>
     

        </div>

      </div>

      <div class="col-12" v-if="teachingMethod == 7 || teachingMethod == 8 || teachingMethod == 10">

        <div class="row"  v-for="session in lastSession">

          <last-session-pecs-results
              :session="session"
              :isRowData="teachingMethod == 10"
              :teachingMethod="teachingMethod"
          />

        </div>

      </div>

    </div>

    <div class="row"  v-show="mode == 'session' && teachingMethod == 9 && stagesList.length">

      <div class="col-12">
        <h4 class="stage-results__title">
          {{'protocol.result_last_assigned_session' | trans}}
          {{'protocol.of_protocol' | trans}} "{{protocolData.protocol.title}}"</h4>
      </div>

      <div class="col-12 without-btn" v-for="stage in stagesList" v-if="!stage.isDisabled">

          <toogle-view :title="stage.description">

            <last-session-category-results
                :protocol-id="protocolId"
                :stage="stage"/>

          </toogle-view>



      </div>
    </div>

    <div class="row mb-3" v-if="isLoaded && (isBCBA || isCurator)" :class="{'visibility-hidden': mode !== 'detail'}">
      <div class="col-12 mt-4">
        <h4 class="stage-results__title">
          {{'protocol.protocol' | trans}}:"{{protocolData.protocol.title}}"</h4>
      </div>
      <div class="col-md-4 col-12"
           v-show="teachingMethod != 8 && teachingMethod != 10">

        <v-select v-model="selectedStage"
                  :options="stagesList"
                  :on-change="onChangeSelectedStage"
                  label="id"
                  name="applying"
                  :filterable="false"
                  :class="{'is-invalid': errors.has('selectedStage'), 'is-clear': !selectedStage}"
                  data-vv-validate-on="none">
          <template slot="option" slot-scope="option">
            {{ option.description}}
          </template>
          <template slot="selected-option" slot-scope="option">
            {{ option.description }}
          </template>
        </v-select>
        <label class="mdc-floating-label">{{isPecsWithDiscrimination ? 'protocol.chooseLevel' : isPecs ? 'protocol.choose_step' :  'protocol.chooseStage' | trans}}</label>
      </div>

    </div>
    <div class="row mb-3" v-if="isLoaded && (isBCBA || isCurator)" :class="{'visibility-hidden': mode !== 'detail'}">
      <div class="col-6 col-md-4">
        <div class="datepicker datepicker__width">
          <span class="datepicker__label">
               {{'report.range_from' | trans }}
          </span>

          <v-date-picker
              v-model='rangeDateStart'
              :class="{'is-invalid': errors.has('rangeDateStart')}"
              name='rangeDateStart'
              :formats='formats'
              title-position="left"
              :input-props='{ readonly: true }'
              :max-date="maxDateStart"
              :min-date="minDateStart"
              v-validate="'required|check-period'"
              data-vv-validate-on="none"
              :label="'rotation.stimulus_one' | trans">
          </v-date-picker>

          <mdc-icon icon="date_range"></mdc-icon>
        </div>
      </div>

      <div class="col-6 col-md-4">
        <div class="datepicker datepicker__width">
          <span class="datepicker__label">
               {{'report.range_end' | trans }}
          </span>

          <v-date-picker
              v-model='rangeDateEnd'
              :formats='formats'
              title-position="left"
              :input-props='{ readonly: true }'
              :max-date="maxDateStart"
              :min-date="rangeDateStart">
          </v-date-picker>

          <mdc-icon icon="date_range"></mdc-icon>
        </div>
      </div>

      <div class="col-12">
        <span class="description-row" :class="{'invalid-feedback': errors.has('rangeDateStart')}">{{'report.description_max_period' | trans }}</span>
      </div>

    </div>

    <div class="row mb-3" v-if="isLoaded && (isBCBA || isCurator)" :class="{'visibility-hidden': mode !== 'detail'}">

      <div class="col-12 text-right">
        <button type="button"
                class="btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0" raised
                @click.prevent="applyFilter(true)">
          {{'report.draw_report' | trans }}
        </button>
      </div>

    </div>

    <div :class="{'visibility-hidden': mode !== 'detail'}">

      <div class="mt-4 position-relative" v-if="isChain">

        <div v-for="stage in stagesList" class="row"  v-if="(!selectedStage || (selectedStage && selectedStage.id == stage.id)) && showReport">
          <current-stage-chain :protocol-id="protocolId" :stage="stage" :rangeDateStartTimestamp="rangeDateStartTimestamp" :rangeDateEndTimestamp="rangeDateEndTimestamp"></current-stage-chain>
        </div>

      </div>

      <div v-if="isShaping">

        <div v-for="stage in stagesList" class="row"  v-if="(!selectedStage || (selectedStage && selectedStage.id == stage.id)) && showReport">
          <current-stage-shaping :protocol-id="protocolId" :is-apply-filter="showReport" :stage="stage" :rangeDateStartTimestamp="rangeDateStartTimestamp" :rangeDateEndTimestamp="rangeDateEndTimestamp"></current-stage-shaping>
        </div>

      </div>

      <div  v-if="isSimple" class="mt-4 position-relative  without-btn">
        <current-simple
          :selectedStage="selectedStage"
          :rangeDateStartTimestamp="rangeDateStartTimestamp"
          :rangeDateEndTimestamp="rangeDateEndTimestamp"
          :protocolId="protocolId"
          :stagesList="stagesList"
          :showReport="showReport"
        />
      </div>

      <div v-if="isUSD && isLoaded">

        <div  v-if="showReport" class="mt-4 position-relative options-mand-list without-btn">

          <h4 class="stage-results__title">{{'report.table_prompts' | trans }}</h4>
          <table-view
              v-if="showReport && (mode == 'detail')"
              :options="optionsStatisticList"
              :isChange="isChangeStatic"
              :isList=isMobile
              class="stimulus_table"
          >
            <div slot="motivationCondition" slot-scope="props" class="nowrap">
              <div v-if="props.row.motivationCondition">{{'admin.yes' | trans }}</div>
              <div v-if="!props.row.motivationCondition">{{'admin.no' | trans }}</div>
            </div>

            <div slot="action" slot-scope="props">
              <div v-if="props.row.name">

                <mdc-checkbox :checked="checkedStimulus(props.row.id)"
                              @change="choseStimulus(props.row, $event)"
                              :disabled="chosenStimul.length == 4 && !checkedStimulus(props.row.id)"/>
              </div>
            </div>

          </table-view>

        </div>

        <div class="col-12" v-if="chosenStimul.length && chartDatasetsForStages" :class="{'mb-1': isChangeStimuli}">

          <div class="row"    v-for="(stage,index) in chartDatasetsForStages">
            <div :class="{'col-md-9' : (chosenStimul.length === 1), 'col-md-12' : chosenStimul.length !== 1  }">

              <line-chart class="row" v-bind:datasets="stage.dataForChart"
                          :scale-label="scaleLabel"
                          v-bind:linedatasets="trendLineArrayPoint[index]"
                          v-bind:list-chart-date="stage.graphReactionDays"
                          v-bind:many-chart="chosenStimul.length > 1"
                          v-bind:show-legend="chosenStimul.length > 1"
                          v-bind:y-axes-begin-at-zero="true"
                          v-bind:vertical-line-point="stage.graphReactionPointArray"
                          v-on:popup-show="popupShow"
                          :persentMax=persentMax
                          :labelText="'%'"
                          :is-mobile="isMobile"
                          :aspect-ratio=false
                          :height="280"
                          :width=null
                          v-if="stage.graphReactionxLabels.length"
              />
              <h4 class="chart__title mb-3" v-if="stage.graphReactionxLabels.length">
                {{'protocol.stimulus_mastering_chart' | trans }}
                <span v-for="(stimul, index) in chosenStimul">{{stimul.name}}<span
                    v-if="index < chosenStimul.length -1">, </span></span>.
                {{stage.description}}
              </h4>

            </div>
            <div class="mt-3 col-md-3" v-if=" chosenStimul.length === 1 && index === 0">
              <mdc-switch v-model="levelLineChecked">{{ 'protocol.levelLine' | trans }}</mdc-switch>
              <mdc-switch v-model="trendLineChecked">{{ 'protocol.trendLine' | trans }}</mdc-switch>
              <mdc-switch v-model="ScatterLineChecked">{{ 'protocol.scatterLine' | trans }}</mdc-switch>
            </div>
          </div>

        </div>

      </div>

      <div v-if="isMand && isLoaded">

        <current-mand
            :selectedStage="selectedStage"
            :rangeDateStartTimestamp="rangeDateStartTimestamp"
            :rangeDateEndTimestamp="rangeDateEndTimestamp"
            :protocolId="protocolId"
            :stagesList="stagesList"
            :showReport="showReport"
            :taskTypesMand="taskTypesMand"
            :clientData="clientData"
        />

      </div>

      <div v-if="isDTT">

        <div class="row"
             v-if="(isBCBA || isCurator) && isLoaded && showReport">

          <div class="col-12 without-btn">

            <div v-for="stage in stagesList" class="row"  v-if="!selectedStage || (selectedStage && selectedStage.id == stage.id)">
              <current-stage-d-t-t :protocol-id="protocolId" :is-apply-filter="showReport" :stage="stage" :rangeDateStartTimestamp="rangeDateStartTimestamp" :rangeDateEndTimestamp="rangeDateEndTimestamp"></current-stage-d-t-t>
            </div>

          </div>

        </div>

      </div>

      <div v-if="isPecs">

        <div  v-if="showReport" class="mt-4 position-relative options-mand-list without-btn">

          <h4 class="stage-results__title">{{'protocol.pecs.table_mastered' | trans }}</h4>
          <table-view
              v-if="showReport && (mode == 'detail')"
              :options="optionsPecsList"
              :isChange="isChangeStatic"
              :isList=isMobile
              class="stimulus_table"
          >
            <div slot="position" slot-scope="props" class="nowrap">
              {{'protocol.step' | trans}} {{props.row.position}}
            </div>

          </table-view>

        </div>

        <div class="row"
             v-if="(isBCBA || isCurator) && isLoaded && showReport">

          <div class="col-12 without-btn">

            <div v-for="stage in stagesList" class="row"  v-if="!selectedStage || (selectedStage && selectedStage.id == stage.id)">
              <current-pecs :protocol-id="protocolId" :is-apply-filter="showReport" :stage="stage" :teachingMethod="teachingMethod" :rangeDateStartTimestamp="rangeDateStartTimestamp" :rangeDateEndTimestamp="rangeDateEndTimestamp"></current-pecs>
            </div>

          </div>

        </div>


      </div>
  
      <div v-if="isPecsWithoutDiscrimination">
        <div class="row"
             v-if="(isBCBA || isCurator) && isLoaded && showReport">
    
          <div class="col-12 without-btn">
            <div v-for="stage in stagesList" class="row"  v-if="!selectedStage || (selectedStage && selectedStage.id == stage.id)">
              <current-pecs apiChartUrl="/protocols/assigned/pecs-without-discrimination/" :protocol-id="protocolId" :teachingMethod="teachingMethod" :stage="stage" :is-apply-filter="showReport" :rangeDateStartTimestamp="rangeDateStartTimestamp" :rangeDateEndTimestamp="rangeDateEndTimestamp"></current-pecs>
            </div>
          </div>
  
        </div>
      </div>

      <div v-if="isPecsWithDiscrimination">
        <div class="row"
             v-if="(isBCBA || isCurator) && isLoaded && showReport">

          <div class="col-12 without-btn" v-if="stagesList.length">

              <current-pecs-with-descrimination
                  apiChartUrl="/protocols/assigned/pecs-with-discrimination/"
                  :protocol-id="protocolId"
                  :teachingMethod="teachingMethod"
                  :stage="selectedStage"
                  :stages-list="stagesList"
                  :is-apply-filter="showReport"
                  :rangeDateStartTimestamp="rangeDateStartTimestamp"
                  :rangeDateEndTimestamp="rangeDateEndTimestamp"/>
          </div>

          <div class="col-12 without-btn">
            <div v-for="category in protocolData.protocol.categories" class="row">
              <current-pecs-category
                  apiChartUrl="/protocols/assigned/pecs-with-discrimination/"
                  :protocol-id="protocolId"
                  :teachingMethod="teachingMethod"
                  :stage="selectedStage"
                  :category="category"
                  :is-apply-filter="showReport"
                  :rangeDateStartTimestamp="rangeDateStartTimestamp"
                  :rangeDateEndTimestamp="rangeDateEndTimestamp"/>
            </div>
          </div>

        </div>
      </div>

      <div v-if="isPecsWithItems">
        <div class="row"
             v-if="(isBCBA || isCurator) && isLoaded && showReport">

          <div class="col-12 without-btn">
            <div v-for="category in protocolData.categories" class="row">
              <current-pecs-category
                  apiChartUrl="/protocols/assigned/pecs-features-with-items/"
                  :protocol-id="protocolId"
                  :teachingMethod="teachingMethod"
                  :stage="selectedStage"
                  :category="category"
                  :is-apply-filter="showReport"
                  :rangeDateStartTimestamp="rangeDateStartTimestamp"
                  :rangeDateEndTimestamp="rangeDateEndTimestamp"/>
            </div>
          </div>

        </div>
      </div>

    </div>

    <cumulutive-chart
        :class="{'visibility-hidden': mode !== 'detail'}"
        :teaching-method="teachingMethod"
        :cumulutiveData="cumulutiveData"
        :selectedStage="selectedStage"
        :protocolId="protocolId"
    />

    <div class="row" v-if="cumulutiveData && showReport && (isPecsWithDiscrimination || isPecsWithItems)">

      <div class="col-12">
        <div class="row" v-for="chart in cumulutiveData" v-if="(selectedStage && chart.stageInfo.id === selectedStage.id) || !selectedStage">

          <div class="col-12"
               v-for="(categoryCumulutiveData, key) in chart.categories">

            <cumulutive-chart
                :class="{'visibility-hidden': mode !== 'detail'}"
                :teaching-method="teachingMethod"
                :cumulutiveData="getData(categoryCumulutiveData)"
                :selectedStage="selectedStage"
                :stageInfo="chart.stageInfo"
                :protocolId="protocolId"
            />
          </div>

        </div>
      </div>

    </div>


    <undesirable-behavior-chart
        :class="{'visibility-hidden': mode !== 'detail'}"
        v-if="clientData"
        :client-id="clientData.id"
        :rangeDateStart="rangeDateStart"
        :rangeDateEnd=rangeDateEnd
        :protocol-id="protocolId"
        :ancedent-id=null
        :behavior-id=null
        :is-apply-changes="changedShow"
        v-on:changedView="changedView"/>

    <div v-if="isModalVisible">

      <chart-popup :visible="isModalVisible"
                   :isVCD="isUSD"
                   :isSimple="isSimple"
                   v-on:close="onClose"
                   :stimulName="!isUSD ? chosenStimul[0].stimulusName : chosenStimul[0].name"
                   chartType="1"
                   :stage-id="isSimple ? selectedStageId : selectedStage ? selectedStage.id : null"
                   :graphTitle="'protocol.stimulus_mastering_chart' | trans"
                   :stimulId="!isUSD && !isSimple ? chosenStimul[0].stimulusId : chosenStimul[0].id"
                   :protocolId="protocolId"
                   :dataPoint="dataPoint">
      </chart-popup>

    </div>

    <div v-if="isPromptModalVisible">

      <chart-popup :visible="isPromptModalVisible"
                   v-on:close="onPromptClose"
                   :stimulName="chosenStimul[0].stimulusName"
                   chartType="2"
                   :graphTitle="'protocol.stimulus_prompt_chart' | trans"
                   :stimulId="chosenStimul[0].stimulusId"
                   :protocolId="protocolId"
                   :dataPoint="dataPoint">
      </chart-popup>

    </div>

  </div>
</template>

<script>
    import axios from 'axios';
    import {mapGetters} from 'vuex';
    import Loader from '../../loader/components/Loader';
    import {LineNonNumericYChart, LineChart, LineChartDataset, LineShapingChart} from '../../../common/chart';
    import forEach from 'lodash/forEach';
    import isEmpty from 'lodash/isEmpty';
    import lang from '../../../lang/translator';
    import moment from 'moment';
    import filter from 'lodash/filter';
    import findIndex from 'lodash/findIndex';
    import minBy from 'lodash/minBy';
    import maxBy from 'lodash/maxBy';
    import toInteger from 'lodash/toInteger';
    import TableView from '../../../common/table/components/TableView';
    import Paginate from 'vuejs-paginate';
    import map from 'lodash/map'
    import Constants from '../../undesirableBehavior/Constants';
    import protocol from '../../../common/protocol/api/protocol';
    import orderBy from 'lodash/orderBy';
    import ceil from 'lodash/ceil';
    import values from 'lodash/values';
    import unique from 'lodash/uniqBy'
    import unionBy from 'lodash/unionBy'
    import sortBy from 'lodash/sortBy'
    import {Validator} from 'vee-validate';
    import Auth from '../../../common/auth/Manager'
    import CurrentStageChain from './CurrentStageChain'
    import CurrentStageShaping from './CurrentStageShaping'
    import CurrentSimple from './CurrentSimple'
    import CurrentMand from './CurrentMand'
    import CurrentStageDTT from './CurrentStageDTT'
    import CurrentPecs from './CurrentPecs'
    import split from 'lodash/split';
    import ChartPopup from './ChartPopup';
    import UndesirableBehaviorChart from '../../undesirableBehavior/components/UndesirableBehaviorChart';
    import CumulutiveChart from "../../chart/component/CumulutiveChart"
    import {typeProtocol} from '../../../common/mixins/typeProtocol';
    import LastSessionResults from './LastSessionResults';
    import LastSessionPecsResults from './LastSessionPecsResults';
    import LastSessionPecsWithDiscrimination from './LastSessionPecsWithDiscrimination';
    import CurrentPecsWithDescrimination from './CurrentPecsWithDescrimination';
    import CurrentPecsCategory from './CurrentPecsCategory';
    import LastSessionCategoryResults from './LastSessionCategoryResults';
    import ToogleView from '@/common/toggleViewList/components/ToggleView';
    import CurrentPecsWithItems from './CurrentPecsWithItems';

    const MODE_SESSIONS = 'session';

    export default {
        props: ['protocolId', 'protocolData', 'clientData'],
        components: {
          CumulutiveChart, LastSessionResults, LastSessionPecsWithDiscrimination, CurrentPecsWithDescrimination, CurrentPecsCategory, LastSessionCategoryResults, CurrentPecsWithItems,
          ChartPopup, CurrentStageChain, CurrentStageShaping, CurrentStageDTT, CurrentSimple, CurrentMand, CurrentPecs, ToogleView,
          Paginate, LineChart, LineNonNumericYChart, LineShapingChart, Loader, TableView, UndesirableBehaviorChart, LastSessionPecsResults},

    data() {
      return {
        sessionDay: null,
        isLoaded: true,
        isChange: false,
        isChangeStimul: false,
        isChangeStatic: false,
        protocolUrl: '/protocols/',
        apiUrl: '/protocols/assigned/',
        measurements: [],
        protocol: {},
        mode: 'session',
        cumulutiveKind: null,
        persentMax: true,
        scaleLabel: lang.get('protocol.total_percent'),
        selectedPhase: null,
        selectedStage: null,
        field: null,
        interval: null,
        intervalList: [
          {id: 1, name: lang.get('protocol.through_each_lesson')},
          {id: 2, name: lang.get('protocol.after_one_lesson')},
          {id: 3, name: lang.get('protocol.after_two_classes')},
          {id: 4, name: lang.get('protocol.after_three_classes')},
          {id: 5, name: lang.get('protocol.once_a_week')},
          {id: 6, name: lang.get('protocol.once_every_two_weeks')},
          {id: 7, name: lang.get('protocol.once_a_month')},
        ],
        rangeDateStart: new Date(),
        rangeDateEnd: new Date(),
        minDateStart: this.getMinDateStart(new Date()),
        maxDateStart: this.getMaxDateStart(new Date()),
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        showReport: false,
        showSimpleReport: false,
        paginate: {
          perPage: 5,
          page: 1,
          forcePage: 0,
          lastPage: null,
          pageRange: 3,
          marginPages: 2,
          chunk: 20,
        },
        optionsStatisticList: {
          perPage: 10,
          pagination: {
            chunk: 20,
          },
          filterable: false,
          debounce: 1000,
          sortable: [],
          withSearch: false,
          skin: 'table table-sm',
          columns: [
            {
              key: 'name',
              changed: false,
              headings: lang.get('protocol.name_mand_reaction')
            },
            {
              key: 'stage',
              changed: false,
              headings: lang.get('protocol.stage')
            },
            {
              key: 'startedAt',
              changed: false,
              headings: lang.get('protocol.started_at')
            },
            {
              key: 'masteredAt',
              changed: false,
              headings: lang.get('protocol.date_mastering')
            },
            {
              key: 'countSamples',
              changed: false,
              headings: lang.get('protocol.countSamples')
            },
            {
              key: 'action',
              changed: true,
              headings: lang.get('protocol.choose_stimul_chart')
            }
          ],
          templates: {
            masteredAt: this.masteredAt,
            startedAt: this.startedAt,
          },
          listRow: {
            name: {
              headings: lang.get('protocol.name_mand_reaction'),
              hasTemplate: false,
            },
            stage: {
              headings: lang.get('protocol.stage'),
              hasTemplate: false,
            },
            startedAt: {
              headings: lang.get('protocol.started_at'),
              hasTemplate: true,
            },
            masteredAt: {
              headings: lang.get('protocol.date_mastering'),
              hasTemplate: true,
            },
            countSamples: {
              headings: lang.get('protocol.countSamples'),
              hasTemplate: false,
            },
          },
          requestFunction: this.requestStimulListFunction,
          responseAdapter: function (resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts: {
            filter: "",
            filterPlaceholder: lang.get('user.type_the_client_code_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
            count: "Страница {page} из {pages}",
          },
          columnsClasses: {
            answerTitle: 'text-center',
            mandLevel: 'text-center',
            motivationCondition: 'text-center',
            countSamples: 'text-center',
          },
          rowClassCallback(row) {
            return row.checked ? "table-info" : "";
          }
        },
        optionsPecsList: {
          perPage: 10,
          pagination: {
            chunk: 20,
          },
          filterable: false,
          debounce: 1000,
          sortable: [],
          withSearch: false,
          skin: 'table table-sm',
          columns: [
            {
              key: 'position',
              changed: true,
              headings: ''
            },
            {
              key: 'startedAt',
              changed: false,
              headings: lang.get('protocol.started_at')
            },
            {
              key: 'masteredAt',
              changed: false,
              headings: lang.get('protocol.date_mastering')
            },
            {
              key: 'countSamples',
              changed: false,
              headings:  lang.get('protocol.countSamples')
            },

          ],
          templates: {
            masteredAt: this.masteredAt,
            startedAt: this.startedAt,
            position: this.position
          },
          listRow: {
            position: {
              headings: '',
              hasTemplate: true,
            },
            startedAt: {
              headings: lang.get('protocol.started_at'),
              hasTemplate: true,
            },
            masteredAt: {
              headings: lang.get('protocol.date_mastering'),
              hasTemplate: true,
            },
            countSamples: {
              headings: lang.get('protocol.countSamples'),
              hasTemplate: false,
            },

          },
          requestFunction: this.requestStimulListFunction,
          responseAdapter: function (resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts: {
            filter: "",
            filterPlaceholder: lang.get('user.type_the_client_code_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
            count: "Страница {page} из {pages}",
          },
          columnsClasses: {
            countSamples: 'text-center',
          },
          rowClassCallback(row) {
            return row.checked ? "table-info" : "";
          }
        },
        mandList: [],
        stimulRezults: [],
        stimulRezultsImproved: [],
        isApplyFilter: false,
        listChartDate: [],
        listChartDateImproved: [],
        listMandChartDate: [],
        verticalLineMandPoint: [],
        hintRezults: [],
        hintRezultsLevels: null,
        trendLinePoint: null,
        trendLinePointImproved:null,
        verticalLinePoint: null,
        verticalLinePointImproved: null,
        phases: [],
        stimulusList: [],
        stimulusListEmpty: false,
        levelLineChecked: false,
        trendLineChecked: false,
        ScatterLineChecked: false,
        levelLineCheckedImproved: false,
        trendLineCheckedImproved: false,
        ScatterLineCheckedImproved: false,
        chosenStimul: [],
        phasesList: [],
        stagesList: [],
        allFields: lang.get('protocol.all_field'),
        isChangeStimuli: false,
        teachingMethod: null,
        graphReaction: null,
        graphReactionPointArray: [],
        graphReactionDays: null,
        graphReactionxLabels: null,
        taskTypesMand: [],
        lastSession: [],
        stimulusId: null,
        selectedId: null,
        measurementMandDay: null,
        measurementDay: null,
        cumulutiveData: null,
        isModalVisible: false,
        isChainModalVisible: false,
        isPromptModalVisible: false,
        dataPoint: null,
        hoveredIndex: null,
        chartDatasetsForStages: null,
        trendLineArrayPoint: [],
        version: null,
        type: null,
        selectedStageId: null,
        measurementsBehavior: null,
        changedShow: false,
        xLabelsShaping: null,
        yLabelsShaping: null,
        measurementsShaping: null,
        lastSessionChart: null,
        xLastSessionChart: null,
        yLastSessionChart: null,
        horizontalLinePointShaping: null,
        chartDatasetsForStimul: null,
        changed: true
      };
    },
    mixins: [typeProtocol],
    computed: {

      ...mapGetters('auth', [
        'isBCBA',
        'isCurator',
        'isClient',
        'user'
      ]),

      ...mapGetters('mobile', [
        'isMobile',
      ]),

      isEmptyMeasurements: function () {
        if (!isEmpty(this.measurements)) {
          if (!isEmpty(this.measurements[0])) {
            return false;
          }
        }
        return true;
      },

      isEmptyMeasurementsList: function () {
        let counter = 0;
        for (let i = 0; i < this.measurements.length; i++) {
          if (isEmpty(this.measurements[i])) {
            counter++;
          }
        }

        if (counter === this.measurements.length) {
          return true;
        }
      },

      rangeDateStartTimestamp() {
        let startDate = new Date(this.rangeDateStart.getFullYear(),
            this.rangeDateStart.getMonth(),
            this.rangeDateStart.getDate(),
            0, 0, 0, 0);
        return moment(startDate).unix() + (Math.abs(this.rangeDateStart.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },

      rangeDateEndTimestamp() {
        let endDate = new Date(this.rangeDateEnd.getFullYear(),
            this.rangeDateEnd.getMonth(),
            this.rangeDateEnd.getDate(),
            23, 59, 59, 59);
        return moment(endDate).unix() + (Math.abs(this.rangeDateEnd.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },

      lineChartDatasetBehavior() {
        return [this.fetchLineDatasetForChartBehavior()];
      },

      barChartAncedentDataset() {
        return this.fetchBarDatasetForChartBehavior(this.antecedentTypes,
          lang.get('behavior.ancedent'));
      },

      barChartBehaviorDataset() {
        return this.fetchBarDatasetForChartBehavior(this.behaviorTypes,
          lang.get('behavior.unwanted_behavior'));
      },

      barChartEffectsDataset() {
        return this.fetchBarDatasetForChartBehavior(this.effectsTypes,
          lang.get('behavior.aftermath'));
      },

    },

    async created() {
      Validator.extend('check-period', {
        getMessage: attribute => lang.get('rotation.unique_stimulus', {attribute}),
        validate: () => {
          let date = new Date(this.rangeDateStart.getFullYear(),
              (this.rangeDateStart.getMonth() + 4),
              this.rangeDateStart.getDate(),
              this.rangeDateEnd.getHours(),
              this.rangeDateEnd.getMinutes(),
              this.rangeDateEnd.getSeconds(),
              this.rangeDateEnd.getMilliseconds()
          );
          return this.rangeDateEnd.getTime() <= date.getTime();
        }
      });

      if (this.clientData) {
        if (this.clientData.timezone) {
          this.setDate();
        } else {
          let dt = new Date();
          let date = new Date(dt.getFullYear(), dt.getMonth(), (dt.getDate() - 7));
          this.rangeDateStart = date;
        }
      }

      let teachingMethod = await this.detectProtocol();

      if (!this.mode) {
        this.mode = MODE_SESSIONS;
      }

      this.fetchMeasurementLastSession();
    },

    methods: {

      getData(data){
        return [{
          absoluteData: data.absoluteData,
          relativeData: data.relativeData,
          stageInfo: this.cumulutiveData[0].stageInfo,
          categoryInfo: data.categoryInfo
        }];
      },


      changedView(){
        this.changedShow = false;
      },

      fetchBarDatasetForChartBehavior(listTypes, name) {
        let data = [], i = 0, label = name, backgroundColor, datasets = [],
          legends = [];

        let types = orderBy(listTypes, 'count', 'desc');

        forEach(types, (item) => {
          data = [
            {
              x: ++i,
              y: item.count,
            },
          ];
          label = item.title;
          backgroundColor = this.getRandomColor();
          legends.push({
            label: label,
            background: backgroundColor,
          });


          datasets.push(new BarChartDataset({
            data, label, labels: legends, backgroundColor, borderColor: backgroundColor,
          }));

        });

        return datasets;
      },

      fetchLineDatasetForChartBehavior() {

        let data = [], i = 0;

        forEach(this.measurementsBehavior, (item) => {
          data.push(
            {
              x: this.toLocaleDate(item.dateRange.end),
              y: item.perHourCount,
            },
          );
        });

        return new LineChartDataset({
          data,
        });

      },

      popupShow(data,stageId, hoveredIndex){

        if(this.chosenStimul.length == 1) {

          let clientTimeZoneOffset = moment().
              tz(this.clientData.timezone)._offset;

          let dateX = data.x;
          let date = split(data.x, ')');
          
          if (date.length > 1){
            dateX = date[date.length - 1];
          }
          

          this.dataPoint = this.teachingMethod == 4 ?  moment.utc(data.x, 'DD.MM.YYYY').unix() : moment.utc(dateX, 'DD.MM.YYYY').unix() +
              (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);

          this.hoveredIndex = hoveredIndex;
          this.selectedStageId = stageId;
          this.isModalVisible = true;

        }

      },

      popupPromptShow(data){
        if(this.chosenStimul.length == 1) {
          let clientTimeZoneOffset = moment().
              tz(this.clientData.timezone)._offset;
          this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix() +
              (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
          this.isPromptModalVisible = true;
        }

      },

      onClose() {
        this.isModalVisible = false;

        this.isChainModalVisible = false;
      },

      onPromptClose() {
        this.isPromptModalVisible = false;
      },


      toLocaleDateTime: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
      },

      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      mandDate(h, row) {
        return row.mandDate ? this.toLocaleDate(row.mandDate.date) : '';
      },

      startedAt(h, row) {
        return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
      },

      mandLevel(h, row) {
        let level = '';
        if (row.mandLevel == 'spontaneous_level') {
          level = lang.get('protocol.spontaneous_level');
        }

        if (row.mandLevel == 'with_subject') {
          level = lang.get('protocol.with_subject');
        }

        return level;
      },

      motivationCondition(h, row) {
        let condition = '';
        if (row.motivationCondition) {
          condition = lang.get('admin.yes');
        } else {
          condition = lang.get('admin.no');
        }

        return condition;
      },

      masteredAt(h, row) {
        return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
      },

      day(h, row) {
        return row.day ? this.toLocaleDate(row.day.date) : '';
      },

      position(h, row) {
        return lang.get('protocol.step') + row.position;
      },

      secondDuration(h, row) {
        let minDuration = toInteger(row.secondDuration/60);
        let secDuration = row.secondDuration - minDuration*60;

        return minDuration + lang.get('report.min') + ' ' + secDuration  + lang.get('report.sec');
      },

      trans: function (key) {
        return lang.get(key);
      },
      clientDateTime(date){
        if (date) {
          let timezone = this.isClient ? Auth.getUserInfo().timezone : this.clientData.timezone;
          if (!timezone) {
            return this.toLocaleDate(moment(date));
          }

          let clientDateEnd = this.toLocaleDate(moment(date).tz(timezone).add(-(moment(date).utcOffset()), 'm')._d);
          return clientDateEnd;
        }
      },
      onChangeSelectedPhase(val) {
        this.selectedPhase = val;
        this.field = null;
        this.fieldList = [];

        if (val.id) {
          if (val.minFieldCount) {
            this.field = null;
            this.fieldList = [];
            for (let i = val.minFieldCount; i <= val.maxFieldCount; i++) {
              this.fieldList.push(i)
            }

            this.fieldList.unshift(this.allFields)
          } else {
            this.intervalList = val.intervals;

            this.intervalList.unshift({
              type: {
                id: null
              }
            })
          }
        }
      },

      checkedStimulus(id) {
        let checked = false;
        if (id && this.chosenStimul.length) {
          forEach(this.chosenStimul, stimul => {
            if (stimul.stimulusId == id || stimul.id == id) {
              checked = true;
            }
          })
        }

        return checked
      },

      choseSimpleStimulus(val, checked) {
        this.isChangeStimuli = true;
        this.showSimpleReport = false;
        if (checked) {
          this.chosenStimul.push(val);

        } else {
          let array = filter(this.chosenStimul, item => {
            return item.name !== val.name
          });
          this.chosenStimul = array;
        }

      },


      async chartSimpleShow(){

        this.showSimpleReport = true;

        this.loaded = true;
      },


      async fetchDataSetForSession(){

        if (this.chosenStimul.length){
          this.isChangeStimul = false;
          this.graphReaction = [];
          let graphReactionPointArray = [];
          let graphReactionChangesArray = [];
          let graphReactionChangesListArray = [];
          let graphReactionDays = [];
          this.graphReactionDays=[];
          let graphReactionDaysWithId = [];
          this.isChangeStimuli = true;
          this.isApplyFilter = true;
          let dataForStimulusList = [];
          let chartDatasets = [];
          let stages = [];
          let countStimul = this.chosenStimul.length;

          for (let [indexStimul, stimul]  of Object.entries(this.chosenStimul)) {

            let id = stimul.id;
            let url = this.apiUrl + 'vcd/' + this.protocolId + '/mensuration/' + id;
            let response = await axios.get(url, {
              params: {
                startDate: this.rangeDateStartTimestamp,
                endDate: this.rangeDateEndTimestamp,
                stageId: this.selectedStage ? this.selectedStage.id : null
              }
            });

            forEach(response.data.data.chartData[0].data, stagesData => {
              let stage = [stagesData.stageInfo]
              stages = unionBy(stages, stage, 'id');
            })

            chartDatasets.push({
              stimul: stimul.name,
              data: response.data.data.chartData[0].data
            });
            graphReactionChangesListArray = unionBy(graphReactionChangesListArray, response.data.data.changes, 'id');

          }
          
          
          forEach(stages, stage => {
            
            forEach(chartDatasets, (stimulData,indexChart) => {
              
              let currentStageChart = filter(stimulData.data, data =>{
                return data.stageInfo.id === stage.id;
              });

              let pointStyle = "rect";

              if (indexChart == 1) {
                pointStyle = "circle";
              }
              if (indexChart == 2) {
                pointStyle = "rectRot";
              }
              if (indexChart == 3) {
                pointStyle = "triangle";
              }
              
              
              

              let chart = new LineChartDataset({
                data: currentStageChart.length ? currentStageChart[0].values : [],
                label: stimulData.stimul,
                pointStyle: pointStyle
              });

              if (!stage.dataForChart){
                stage.dataForChart = [];
                stage.graphReactionDays = [];
                stage.graphReactionxLabels = [];
                stage.graphReactionPointArray = [];
                stage.values = [];
              }

              stage.dataForChart.push(chart);

              if (currentStageChart.length){
                stage.graphReactionDays = unique(unionBy(stage.graphReactionDays, currentStageChart[0].dayVersions, 'day'));
                stage.graphReactionxLabels = currentStageChart[0].xLabels;
                stage.values = currentStageChart[0].values;

              }
            });

            stage.graphReactionDays = sortBy(stage.graphReactionDays, ['id', (date) => {
              return moment(date.day, 'DD.MM.YYYY').unix();
            }, (date) => {
              return date.day.length;
            }]);


            stage.xLabels = [];

            forEach(stage.graphReactionDays, (day,index) => {

              if(index > 0 && day.id !== stage.graphReactionDays[index - 1].id){

                let lastId = day.id;
                let firstId = stage.graphReactionDays[index - 1].id;

                let changes = filter(graphReactionChangesListArray, change => {
                  return change.id >firstId  &&  change.id <=lastId
                });

                forEach(changes, change => {

                  let indexChange = findIndex(graphReactionChangesListArray, item => {
                    return item.id == change.id
                  });

                  stage.xLabels.push({
                    id: change.id,
                    day: 'Изменения ' + (indexChange+1)

                  });

                  stage.graphReactionPointArray.push({
                    x: 'Изменения ' + (indexChange+1),
                    isImportant: change.isImportant,
                    comment: change.comment
                  })

                });
              }

              stage.xLabels.push(day);

            });
            
            stage.graphReactionDays = map(stage.xLabels, 'day');
          
          });
          
          this.chartDatasetsForStages = stages;

          this.isApplyFilter = false;
          this.isLoaded = true;
          this.isChangeStimul = false;

          if (this.chosenStimul.length === 1 && (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked)) {
            forEach(this.chartDatasetsForStages, (dataSet, key) => {
              this.trendLineArrayPoint[key] = this.fetchDatasetLineTrend(dataSet.values, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
            });
          } else{
            forEach(this.chartDatasetsForStages, (dataSet, key) => {
              this.trendLineArrayPoint[key] = null;
            });
          }

          /*if (this.chosenStimul.length === 1 && (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked)) {
            this.trendLinePoint = this.fetchDatasetLineTrend(dataset, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
          } else {
            this.trendLinePoint = null;
          }*/

        }
        
        
      },

      choseStimulus(val, checked) {
        this.isChangeStimuli = true;
        if (checked) {
          this.chosenStimul.push(val);
        } else {
          let array = filter(this.chosenStimul, item => {
            return this.teachingMethod != 4 ? item.stimulusName !== val.stimulusName : item.name !== val.name
          });
          this.chosenStimul = array;
        }

        if (this.chosenStimul.length == 1 && this.teachingMethod != 4) {
          this.fetchDatasetForStimulus();
        }

        if (this.chosenStimul.length > 1 && this.teachingMethod != 4) {
          this.fetchDatasetForStimulusList();
        }
        
        if (this.teachingMethod == 4){
          this.fetchDataSetForSession()
        }

        if (!this.chosenStimul.length) {
          this.isChangeStimuli = false;

        }
      },

      fetchTaskTypes: async function () {
        try {

          let response = await axios.get(this.protocolUrl + 'task-types/');

          this.taskTypesMand = response.data.data.filter((item) => {
            return item.id == 6;
          })[0].answers;

        } catch (error) {
          console.dir(error);
        }
      },

      async fetchDatasetForStimulus(){
        let stimul = this.chosenStimul[this.chosenStimul.length - 1];
        let params = {
          stageId: this.selectedStage ? this.selectedStage.id : null,
          startDate: this.rangeDateStartTimestamp,
          endDate: this.rangeDateEndTimestamp,
        };

        let response = await axios.get(
            `${this.apiUrl}${this.protocolId}/measurement/stimulus/${stimul.stimulusId}`, {params: params});

        let stimulus = response.data.data.himself;
        let hints = response.data.data.promptLevels;
        let improved = response.data.data.improvedAnswerStat;
        let data = [];
        let dataImproved = [];
        let dataHint = {};

        forEach(stimulus, (item, index) => {
          let changes = lang.get('report.changes_from');
          let repeatDate = null;
          let repeatDateNumber = 0;

          let countDay = filter(stimulus, day => {
            return item.day == day.day;
          });

          let firstDay = findIndex(stimulus, day => {
            return item.day == day.day;
          });

          if (countDay.length > 1) {

            if (stimulus[index - 1]) {
              if (item.day == stimulus[index - 1].day) {
                repeatDate = index;
                repeatDateNumber = index - firstDay + 1;
                changes = item.isChanged ? '(' + repeatDateNumber + ') ' + lang.get('report.changes_from') : '(' + repeatDateNumber + ') ';
              }
            }

            if (stimulus[index + 1]) {
              if (item.day == stimulus[index + 1].day) {
                repeatDate = index;
                repeatDateNumber = index - firstDay + 1;
                changes = item.isChanged ? '(' + repeatDateNumber + ') ' + lang.get('report.changes_from') : '(' + repeatDateNumber + ') ';
              }
            }

          }

          data.push(
              {
                x: item.isChanged || repeatDate ?
                    changes + this.toLocaleDate(item.day) :
                    this.toLocaleDate(item.day),
                y: item.isChanged ? changes + this.toLocaleDate(item.day) : ceil(item.himself * 100),
                comment: item.isChanged ? item.comment : '',
                isChanged: item.isChanged,
                isImportant: item.isImportant,
                left: index < (stimulus.length / 2),
                right: index > (stimulus.length / 2)
              },
          );


        });

        forEach(improved, (item, index) => {
          let changes = lang.get('report.changes_from');
          let repeatDate = null;
          let repeatDateNumber = 0;

          let countDay = filter(stimulus, day => {
            return item.day == day.day;
          });

          let firstDay = findIndex(stimulus, day => {
            return item.day == day.day;
          });

          if (countDay.length > 1) {

            if (stimulus[index - 1]) {
              if (item.day == stimulus[index - 1].day) {
                repeatDate = index;
                repeatDateNumber = index - firstDay + 1;
                changes = item.isChanged ? '(' + repeatDateNumber + ') ' + lang.get('report.changes_from') : '(' + repeatDateNumber + ') ';
              }
            }

            if (stimulus[index + 1]) {
              if (item.day == stimulus[index + 1].day) {
                repeatDate = index;
                repeatDateNumber = index - firstDay + 1;
                changes = item.isChanged ? '(' + repeatDateNumber + ') ' + lang.get('report.changes_from') : '(' + repeatDateNumber + ') ';
              }
            }

          }

          dataImproved.push(
              {
                x: item.isChanged || repeatDate ?
                    changes + this.toLocaleDate(item.day) :
                    this.toLocaleDate(item.day),
                y: item.isChanged ? changes + this.toLocaleDate(item.day) : ceil(item.improved * 100),
                comment: item.isChanged ? item.comment : '',
                isChanged: item.isChanged,
                isImportant: item.isImportant,
                left: index < (stimulus.length / 2),
                right: index > (stimulus.length / 2)
              },
          );


        });

        this.hintRezultsLevels = hints.levels;

        forEach(this.hintRezultsLevels, (item, index) => {
          dataHint[index] = [];
          forEach(hints.prompts, (promptItem) => {

            let prompt = filter(promptItem.prompts, function (o) {
              return item.level === o.level;
            });

            if (prompt.length) {
              dataHint[index].push({
                x: this.toLocaleDate(promptItem.day.date),
                y: item.description
              })
            } else {
              dataHint[index].push({
                x: this.toLocaleDate(promptItem.day.date),
                y: null
              })
            }

          });


        });

        this.verticalLinePoint = filter(data, point => {
          return point.isChanged;
        });

        this.verticalLinePointImproved = filter(dataImproved, point => {
          return point.isChanged;
        });

        if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
          this.trendLinePoint = this.fetchDatasetLineTrend(data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
        } else {
          this.trendLinePoint = null;
        }

        if (this.trendLineCheckedImproved || this.levelLineCheckedImproved || this.ScatterLineCheckedImproved) {
          this.trendLinePointImproved = this.fetchDatasetLineTrend(dataImproved, this.trendLineCheckedImproved, this.levelLineCheckedImproved, this.ScatterLineCheckedImproved);
        } else {
          this.trendLinePointImproved = null;
        }


        let listChartDate = map(data, (item) => {
          return item.x;
        });

        if (data.length) {
          if (data[data.length - 1]) {
            listChartDate.push('')
          }
          if (data[0]) {
            listChartDate.unshift('')
          }
        }

        this.listChartDate = listChartDate;

        let listChartDateImproved = map(dataImproved, (item) => {
          return item.x;
        });

        if (data.length) {
          if (data[data.length - 1]) {
            listChartDateImproved.push('')
          }
          if (data[0]) {
            listChartDateImproved.unshift('')
          }
        }

        this.listChartDateImproved = listChartDateImproved;


        let dataList = filter(data, point => {
          return !point.isChanged || (point.isChanged && point.isImportant);
        });

        let dataListImproved = filter(dataImproved, point => {
          return !point.isChanged || (point.isChanged && point.isImportant);
        });

        let stimDataset = new LineChartDataset({
          data: dataList,
        });

        this.stimulRezults = [stimDataset]

        this.stimulRezultsImproved = [ new LineChartDataset({
          data: dataListImproved,
        })];

        this.hintRezultsLevels = map(hints.levels, 'description');
        this.hintRezultsLevels.push('');
        this.hintRezultsLevels.unshift(' ');

        let hintRezults = [];

        forEach(dataHint, (dataItem) => {
          hintRezults.push(new LineChartDataset({
            data: dataItem,
          }))
        });

        this.hintRezults = hintRezults;
        this.isChangeStimuli = false;

        return this.stimulRezults;
      },

      findMaxCountDate(list, date){
        let max = 0;
        let countDay = 0;

        forEach(list, (item, index) => {
          countDay = filter(item, (day) => {
            return date == day.day && !day.isChanged;
          }).length;

          if (countDay > max) {
            max = countDay;
          }

        });

        return max;

      },

      async fetchDatasetForStimulusList(){

        let dataForStimulusList = [];
        let dataForStimulusListImproved = [];
        let listChartDate = [];
        let listChartDateImproved = [];
        let i = 0;
        let stimulusList = [];
        let stimulusListImproved = [];

        for (let stimul of this.chosenStimul) {
          let params = {
            stageId: this.selectedStage ? this.selectedStage.id : null,
            startDate: this.rangeDateStartTimestamp,
            endDate: this.rangeDateEndTimestamp,
          };

          let response = await axios.get(`${this.apiUrl}${this.protocolId}/measurement/stimulus/${stimul.stimulusId}`, {params: params});
          let himself = {
            himself: response.data.data.himself,
            stimulusName: stimul.stimulusName
          };

          let improved = {
            improved: response.data.data.improvedAnswerStat,
            stimulusName: stimul.stimulusName
          };
          stimulusList.push(himself);
          stimulusListImproved.push(improved);
        }


        forEach(stimulusList, (stimulus, i) => {

          forEach(stimulus.himself, (item, index) => {
            let countDayChanged = filter(stimulus.himself, day => {
              return item.day == day.day && day.isChanged;
            });

            if (countDayChanged.length > 1) {
              let dayChangedList = map(countDayChanged, (day, index) => {
                let changeIndex = parseInt(index) + 1;
                day.label = '(' + changeIndex + ') ' + lang.get('report.changes_from');
                day.labelIndex = changeIndex;
                return day;
              });
            }

            if (countDayChanged.length == 1) {
              countDayChanged[0].label = lang.get('report.changes_from');
              countDayChanged[0].labelIndex = index;
            }

          });

        });

        forEach(stimulusListImproved, (stimulus, i) => {

          forEach(stimulus.improved, (item, index) => {
            let countDayChanged = filter(stimulus.improved, day => {
              return item.day == day.day && day.isChanged;
            });

            if (countDayChanged.length > 1) {
              let dayChangedList = map(countDayChanged, (day, index) => {
                let changeIndex = parseInt(index) + 1;
                day.label = '(' + changeIndex + ')' + lang.get('report.changes_from');
                day.labelIndex = changeIndex;
                return day;
              });
            }

            if (countDayChanged.length == 1) {
              countDayChanged[0].label = lang.get('report.changes_from');
              countDayChanged[0].labelIndex = index;
            }

          });

        });

        forEach(stimulusList, (stimulus, i) => {
          let pointStyle = "rect";

          if (i == 1) {
            pointStyle = "circle";
          }
          if (i == 2) {
            pointStyle = "rectRot";
          }
          if (i == 3) {
            pointStyle = "triangle";
          }

          let data = [];

          forEach(stimulus.himself, (item, index) => {

            if (stimulus.himself[index - 1] && stimulus.himself[index - 1].label) {

              if (stimulus.himself[index - 1].label && stimulus.himself[index - 1].day == item.day && !item.isChanged) {
                item.label = '(' + stimulus.himself[index - 1].labelIndex + ') '
                item.labelIndex = stimulus.himself[index - 1].labelIndex
              }
            }


            listChartDate.push({
              day: item.day,
              label: item.label ?
                  item.label + this.toLocaleDate(item.day) :
                  this.toLocaleDate(item.day),
              labelIndex: item.label ? item.labelIndex : index
            });

            data.push(
                {
                  x: item.label ?
                      item.label + this.toLocaleDate(item.day) :
                      this.toLocaleDate(item.day),
                  y: item.isChanged ? item.label + this.toLocaleDate(item.day) : ceil(item.himself * 100),
                  comment: item.isChanged ? item.comment : '',
                  isChanged: item.isChanged,
                  isImportant: item.isImportant,
                  left: index < (stimulus.himself.length / 2),
                  right: index > (stimulus.himself.length / 2)
                },
            );

            this.verticalLinePoint = filter(data, point => {
              return point.isChanged;
            });

            this.trendLinePoint = null;
          });


          let dataList = filter(data, point => {
            return !point.isChanged || (point.isChanged && point.isImportant);
          });

          let stimDataset = new LineChartDataset({
            label: stimulus.stimulusName,
            data: dataList,
            pointStyle: pointStyle
          });

          dataForStimulusList.push(stimDataset);

        });


        forEach(stimulusListImproved, (stimulus, i) => {
          let pointStyle = "rect";

          if (i == 1) {
            pointStyle = "circle";
          }
          if (i == 2) {
            pointStyle = "rectRot";
          }
          if (i == 3) {
            pointStyle = "triangle";
          }

          let dataImproved = [];

          forEach(stimulus.improved, (item, index) => {

            if (stimulus.improved[index - 1] && stimulus.improved[index - 1].label) {

              if (stimulus.improved[index - 1].label && stimulus.improved[index - 1].day == item.day && !item.isChanged) {
                item.label = '(' + stimulus.improved[index - 1].labelIndex + ') '
                item.labelIndex = stimulus.improved[index - 1].labelIndex
              }
            }


            listChartDateImproved.push({
              day: item.day,
              label: item.label ?
                  item.label + this.toLocaleDate(item.day) :
                  this.toLocaleDate(item.day),
              labelIndex: item.label ? item.labelIndex : index
            });

            dataImproved.push(
                {
                  x: item.label ?
                      item.label + this.toLocaleDate(item.day) :
                      this.toLocaleDate(item.day),
                  y: item.isChanged ? item.label + this.toLocaleDate(item.day) : ceil(item.improved * 100),
                  comment: item.isChanged ? item.comment : '',
                  isChanged: item.isChanged,
                  isImportant: item.isImportant,
                  left: index < (stimulus.improved.length / 2),
                  right: index > (stimulus.improved.length / 2)
                },
            );

            this.verticalLinePointImproved = filter(dataImproved, point => {
              return point.isChanged;
            });

            this.trendLinePointImproved = null;
          });



          let dataList = filter(dataImproved, point => {
            return !point.isChanged || (point.isChanged && point.isImportant);
          });

          let stimDatasetImproved = new LineChartDataset({
            label: stimulus.stimulusName,
            data: dataList,
            pointStyle: pointStyle
          });

          dataForStimulusListImproved.push(stimDatasetImproved);

        });


        this.hintRezults = [];
        listChartDate = unique(listChartDate, 'label');
        listChartDate = sortBy(listChartDate, 'labelIndex');


        listChartDate = sortBy(listChartDate, (date) => {
          return new moment(date.day).unix();
        });


        this.listChartDate = map(listChartDate, (date) => {
          return date.label;
        });

        if (this.listChartDate.length) {
          if (this.listChartDate[this.listChartDate.length - 1]) {
            this.listChartDate.push('')
          }
          if (this.listChartDate[0]) {
            this.listChartDate.unshift(' ')
          }
        }

        this.stimulRezults = dataForStimulusList;
        this.stimulRezultsImproved = dataForStimulusListImproved;
        this.isChangeStimuli = false;
        return dataForStimulusList;


      },

      async onChangeSelectedStage(val) {
        this.selectedStage = val;

        /*if (this.isDTTProtocol) {

          this.selectedPhase = null;
          this.phasesList = [];
          this.field = null;
          this.interval = null;

          if (val.id) {

            let stageId = val.id;

            let url = `${this.apiUrl}${this.protocolId}/measurement/${stageId}/phases`;
            let response = await axios.get(url);

            this.phasesList = orderBy(response.data.data, 'position', 'asc');

            this.phasesList.unshift({
              id: null,
              typeId: 0,
              title: lang.get('protocol.all_phases')
            })

          }

        }*/

        // add get info about selected stage

      },

      async requestStimulListFunction (data) {
        this.isChangeStatic = false;
        return this.onSendReactionListRequest(this.optionsStatisticList.perPage, data.page);
      },

      applyFilter: async function (change = false) {

        if(change){
          this.isLoaded = false;
          this.selectedId = null;
          this.showReport = false;
          this.changedShow = true;
        }

        let result = await this.$validator.validateAll();

        if (!result) {
          this.disabled = false;
          this.loaded = false;
          this.isLoaded = true;
          this.showReport = false;
          return;
        }

        if(change) {

          this.isApplyFilter = true;

          if (this.teachingMethod != 1 && this.teachingMethod != 6) {

            if (change || !this.cumulutiveData) {
              this.showReport = false;
              this.fetchTaskTypes();
              this.isChangeStatic = true;

              let apiUrl = this.apiUrl;

              switch (this.teachingMethod) {
                case 2:
                  apiUrl = this.apiUrl + 'simple/';
                  break;
                case 3:
                  apiUrl = this.apiUrl + 'mand/';
                  break;
                case 4:
                  apiUrl = this.apiUrl + 'vcd/';
                  break;
                case 5:
                  apiUrl = this.apiUrl + 'chain/';
                  break;
                case 7:
                  apiUrl = this.apiUrl + 'pecs-sentence-structure/';
                  break;
                case 8:
                  apiUrl = this.apiUrl + 'pecs-without-discrimination/';
                  break;
                case 9:
                  apiUrl = this.apiUrl + 'pecs-with-discrimination/';
                  break;
                case 10:
                  apiUrl = this.apiUrl + 'pecs-features-with-items/';
                  break;

              }
              let url = apiUrl + this.protocolId + '/mastered-cumulative-stat';
              let response = await axios.get(url);
              this.cumulutiveData = response.data.data;
              this.isChangeStatic = false;
            }
            if (!this.selectedId) {
              this.isApplyFilter = false;
            }

          }

          if (this.teachingMethod == 1) {
            this.fetchDatasetForCumulutiveChartDTT();
          }

          if (this.teachingMethod == 6) {
            this.isApplyFilter = false;
          }

          this.isChange = true;
          this.chosenStimul = [];
          this.isLoaded = true;
          setTimeout(() => {
            this.showReport = true;
          }, 100);

        }

      },

      async fetchDatasetForCumulutiveChartDTT(){
        let url = this.apiUrl + 'dtt/' + this.protocolId + '/mastered-cumulative-stat';
        let response = await axios.get(url);
        this.cumulutiveData = response.data.data;
        this.isApplyFilter = false;
      },


      onSendReactionListRequest: async function (perPage, page) {
        this.mandList = [];


        let url = this.apiUrl;

        switch (this.teachingMethod) {
          case 1:
            url = this.apiUrl + 'dtt/' + this.protocolId + '/stimuli-introduced-mastered-history/';
            break;
          case 2:
            url = this.apiUrl + 'simple/' + this.protocolId + '/stimuli-reactions-statistics/';
            break;
          case 4:
            url = this.apiUrl + 'vcd/' + this.protocolId + '/stimuli-introduced-mastered-history/';
            break;
          case 3:
            url = this.apiUrl + 'mand/' + this.protocolId + '/stimuli-reactions-statistics/';
            break;
          case 7:
            url = this.apiUrl + 'pecs-sentence-structure/' + this.protocolId + '/stage-introduced-mastered-history/';
            break;

        }


        //let url = this.teachingMethod == 3 ? this.apiUrl + 'mand/' + this.protocolId + '/stimuli-reactions-statistics/' : this.apiUrl + 'vcd/' + this.protocolId + '/stimuli-introduced-mastered-history/';
        //let url = this.apiUrl + 'mand/' + this.protocolId + '/stimuli-reactions-statistics/'
        let params = {
          perPage: perPage,
          page: page,
          stageId: this.selectedStage ? this.selectedStage.id : null,
          startDate: this.rangeDateStartTimestamp,
          endDate: this.rangeDateEndTimestamp,
        };
        let response = await axios.get(url, {params: params});
        this.mandList = response.data.data.items;
        return response;
      },


      onSendMandLastSessionRequest: async function (perPage, page) {
        let url = this.apiUrl + 'mand/' + this.protocolId + '/last-sessions';
        let params = {
          perPage: perPage,
          page: page
        };
        let response = await axios.get(url, {params: params});
        this.isApplyFilter = false;
        return response;
      },

      answerTitle: function (answer, mandLast) {
        let title = filter(mandLast.answers, item => {
          return item.id == answer
        });

        return title.length ? title[0]['title'] : '';
      },


      getMinDateStart: function (date) {
        let minDateStart = new Date((date.getFullYear() - 1), date.getMonth(),
            date.getDate());
        return minDateStart;
      },
      getMaxDateStart: function (date) {

        if (this.clientData && this.clientData.timezone) {
          let clientDateEnd = moment().tz(this.clientData.timezone).add(-(moment().utcOffset()), 'm');

          return clientDateEnd._d;
        } else {
          return new Date();
        }
      },

      setDate() {
        let clientDateStart = moment().tz(this.clientData.timezone).subtract(Constants.COUNT_DAY, 'days').add(-(moment().utcOffset()), 'm');
        let clientDateEnd = moment().tz(this.clientData.timezone).add(-(moment().utcOffset()), 'm');

        this.rangeDateStart = clientDateStart._d;
        this.rangeDateEnd = clientDateEnd._d;

      },


      detectProtocol: async function () {
        let protocolId = this.protocolId ? this.protocolId : this.protocolData.id;
        let response = await axios.get(this.apiUrl + protocolId + '/teaching-method');
        this.teachingMethod = response.data.data.id;
        return this.teachingMethod;
      },

      fetchMeasurementLastSession: async function () {
        try {
          this.isLoaded = false;
          if (!this.mode) {
            this.mode = MODE_SESSIONS;
          }

          let url;

          switch (this.teachingMethod) {
            case 1:
              url = this.apiUrl + 'dtt/';
              break;
            case 2:
              url = this.apiUrl + 'simple/';
              break;
            case 3:
              url = this.apiUrl + 'mand/';
              break;
            case 4:
              url = this.apiUrl + 'vcd/';
              break;
            case 5:
              url = this.apiUrl + 'chain/';
              break;
            case 6:
              url = this.apiUrl + 'shaping/';
              break;
            case 7:
              url = this.apiUrl + 'pecs-sentence-structure/';
              break;
            case 8:
              url = this.apiUrl + 'pecs-without-discrimination/';
              break;
            case 9:
              url = this.apiUrl + 'pecs-with-discrimination/';
              break;
            case 10:
              url = this.apiUrl + 'pecs-features-with-items/';
              break;
          }

            let response = null;

            if(this.teachingMethod === 9) {
              this.isLoaded = true;
            } else {
              response = await axios.get(url + this.protocolId +
                  '/last-sessions');
              this.lastSession = this.teachingMethod == 6 ?
                  response.data.data.resultMensuration :
                  response.data.data;
              this.measurementDay = this.lastSession.day;
            }

            this.stagesList = [{
              id: null,
              title: lang.get('protocol.all_stage')
            }];

            this.stagesList = this.protocolData.protocol.stages;

            if(this.teachingMethod == 6){
              this.lastSessionChart = response.data.data.charts;
            }

            this.isLoaded = true;

          /*if (response){
            this.isLoaded = true;
          }*/
        } catch (error) {
          console.dir(error);
          if(error.status === 403) {
            //this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
          }
        }
      },



      fetchShapingMeasurement: async function () {
        try {
          this.isLoaded = false;

          let url = this.apiUrl + 'shaping/'+ this.protocolId +'/mensuration/';
          let chartTypes = [];
          let response = await axios.get(url,{
            params: {
              startDate: this.rangeDateStartTimestamp,
              endDate: this.rangeDateEndTimestamp,
              stageId: this.selectedStage ? this.selectedStage.id : null,
            }
          });

          this.measurementsShaping = response.data.data.data;
          this.xLabelsShaping = response.data.data.xLabels;
          this.yLabelsShaping = response.data.data.yLabels;

        } catch (error) {
          console.dir(error);
        } finally {
          this.isLoaded = true;
          this.isChange = true;
          this.showReport = true;
          this.isApplyFilter = false;
        }
      },

      fetchDatasetForShapingChart(data){
        let dataChart = [];

        forEach(data, chart => {
          dataChart.push(new LineChartDataset({
            data: chart,
            pointBorderWidth: 2
          }));

          let value = split(chart[0].y, '_');

          dataChart.push(new LineChartDataset({
            data: [
              {
                x: chart[0].x,
                y: value[0] + '_0',
              },
              {
                x: chart[chart.length - 1].x,
                y: value[0] + '_0',
              },
            ],
            pointRadius: 0,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            borderWidth: 2,
            borderDash: [12,10]
          }));

        });

        return dataChart;

      },

      fetchDatasetForChart(item) {
        let data = [], i = 0;

        if (item.info.taskType && (item.info.taskType.id === 1) && !item.phaseTypeId) {
          item.scaleLabel = lang.get('protocol.mastered_stimuli');
          forEach(item.mastering, (day) => {
            data.push(
                {
                  x: day.isChanged ?
                    lang.get('report.changes_from') + day.day :
                      this.toLocaleDate(day.day),
                  y: day.isChanged ? lang.get('report.changes_from') + day.day : day.percent,
                  comment: day.isChanged ? day.comment : '',
                  isChanged: day.isChanged,
                  isImportant: day.isImportant,

                },
            );
          });
        } else {

          item.scaleLabel = item.info.type !==
          'dtt_protocol_mastering_results' ?
              lang.get('protocol.average_percent') :
              lang.get('protocol.mastering_percent');

          if (item.dayMensuration) {
            if (item.dayMensuration[0]) {
              if (item.dayMensuration[0].isChanged) {
                data.push({
                  x: '',
                  y: -6,
                });
              }
            }
          }
          forEach(item.dayMensuration, (day, index) => {
            let changes = lang.get('report.changes_from');
            let next = '';
            if (index > 1) {
              if (day.isChanged && item.dayMensuration[index - 1].isChanged) {
                let count = 0;
                let countArr = filter(item.dayMensuration, x => {
                  return x.day == day.day && x.isImportant
                })

                forEach(countArr, (x, index) => {
                  if (x.comment == day.comment) {
                    count = index + 1;
                  }
                })
                count = ' / ' + index;
              }
            }

            data.push(
                {
                  x: day.isImportant ?
                      changes + this.toLocaleDate(day.day) + next :
                      this.toLocaleDate(day.day),
                  y: day.isChanged ? changes + day.day : day.percent,
                  comment: day.isChanged ? day.comment : '',
                  isChanged: day.isChanged,
                  isImportant: day.isImportant,
                  left: index <= toInteger(item.dayMensuration.length / 2),
                  right: index >= toInteger(item.dayMensuration.length / 2)
                },
            );

            if (day.isChanged && index == item.dayMensuration.length - 1) {
              data.push({
                x: ' ',
                y: -6,
              });
            }
          });

          let array = [];

          forEach(data, (point, index) => {
            if (point.isChanged && !point.isImportant && data[index - 1] && data[index + 1]) {

              if (!(data[index - 1].x == point.x || data[index + 1].x == point.x)) {

                point.y = (data[index - 1].y + data[index + 1].y) / 2;
                point.left = index <= toInteger(item.dayMensuration.length / 2);
                point.right = index >= toInteger(item.dayMensuration.length / 2)
                point.enabled = false;
                array.push(point);

              }

            } else {

              array.push(point);
            }
          });

          item.verticalLinePoint = filter(data, point => {
            return point.isChanged;
          });

          data = array;

        }

        return new LineChartDataset({
          data,
        });
      },

      chooseStimul(stim, item, key, count) {
        if (count) {
          item.choosenStimul = stim;
          this.$set(this.measurements, key, item);
        }
      },

      fetchDatasetStimulusForChart(item) {
        let data = [], i = 0;

        item.scaleLabel = item.info.type !==
        'dtt_protocol_mastering_results' ?
            lang.get('protocol.average_percent') :
            lang.get('protocol.mastering_percent');

        forEach(item.dayMensuration, (day, index) => {
          let percent = null;
          let stimul = [];
          let addPoint = true;
          let changesLine = [];
          let changes = lang.get('report.changes_from');
          if (item.choosenStimul && day.stimuli) {
            stimul = filter(day.stimuli, st => {
              return st.description == item.choosenStimul.description;
            });
            percent = stimul[0] ? stimul[0].analytics.himself.percent : null;
            if (stimul[0] && !day.isChanged) {
              addPoint = !(percent == 0 && stimul[0].analytics.attempts == 0);
            }
          }
          if (index > 1) {
            if (day.isChanged && item.dayMensuration[index - 1].isChanged) {
              let count = 0;
              let countArr = filter(item.dayMensuration, x => {
                return x.day == day.day && x.isImportant
              })

              forEach(countArr, (x, index) => {
                if (x.comment == day.comment) {
                  count = index + 1;
                }
              })
              changes = count + ' ' + lang.get('report.changes_from') + ' ';
            }
          }

          if (addPoint && (stimul.length || day.isChanged)) {

            data.push(
                {
                  x: day.isImportant ?
                      changes + this.toLocaleDate(day.day) :
                      this.toLocaleDate(day.day),
                  y: day.isChanged ? changes + day.day : percent,
                  comment: day.isChanged ? day.comment : '',
                  isChanged: day.isChanged,
                  isImportant: day.isImportant,
                  left: index <= toInteger(item.dayMensuration.length / 2),
                  right: index >= toInteger(item.dayMensuration.length / 2)
                },
            );

          }

        });

        if (item.trendLine || item.levelLine || item.ScatterLine) {
          item.trendLinePoint = this.fetchDatasetLineTrend(data, item.trendLine, item.levelLine, item.ScatterLine);
        } else {
          item.trendLinePoint = null;
        }


        let array = [];

        forEach(data, (point, index) => {
          if (point.isChanged && !point.isImportant && data[index - 1] && data[index + 1]) {

            if (!(data[index - 1].x == point.x || data[index + 1].x == point.x)) {

              point.y = (data[index - 1].y + data[index + 1].y) / 2;
              point.left = index <= toInteger(item.dayMensuration.length / 2);
              point.right = index >= toInteger(item.dayMensuration.length / 2)
              array.push(point);

            }

            if (data[index - 1].x == point.x) {
              point.left = true;
              point.right = false;

            }

            if (data[index + 1].x == point.x) {
              point.left = false;
              point.right = true;
            }

          } else {
            array.push(point);
          }
        });

        item.verticalLinePoint = filter(data, point => {
          return point.isChanged;
        });

        data = array;

        if (data[0]) {
          if (data[0].isChanged) {
            data.unshift({
              x: ' ',
              y: -6,
            });
          }
        }

        if (data[data.length - 1]) {
          if (data[data.length - 1].isChanged) {
            data.push({
              x: ' ',
              y: -6,
            });
          }
        }

        /* return new LineChartDataset({
         data,
         });*/
      },

      trendLine(item) {
        let SumOfPowX = 0, SumOfX = 0, n = item.length, SumOfXY = 0, SumOfY = 0;

        for (let i = 0; i < n; i++) {
          SumOfPowX += (i + 1) * (i + 1);
          SumOfX += (i + 1);
          SumOfXY += (i + 1) * item[i].y;
          SumOfY += item[i].y;
        }
        let det = SumOfPowX * n - Math.pow(SumOfX, 2);
        let a = (SumOfXY * n - SumOfX * SumOfY) / det;
        let b = (SumOfY - a * SumOfX) / n;

        let first = a + b;
        let last = a * n + b;

        let data = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: first,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n - 1].x,
            y: last,
          },
        ];

        let dataset = new LineChartDataset({
          data,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        return dataset

      },

      levelLine(item) {
        let n = item.length, SumOfY = 0, y = 0;

        forEach(item, point => {
          SumOfY += point.y;
        });

        y = SumOfY / n;

        let data = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: y,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n - 1].x,
            y: y,
          },
        ];

        let dataset = new LineChartDataset({
          data,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        return dataset

      },

      scatterLine(item) {
        let n = item.length, SumOfY = 0, y = 0;

        let min = minBy(item, function (o) {
          return o.y;
        });
        let max = maxBy(item, function (o) {
          return o.y;
        });


        let dataMin = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: min,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n - 1].x,
            y: min,
          },
        ];

        let dataMax = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: max,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n - 1].x,
            y: max,
          },
        ];

        let datasetMin = new LineChartDataset({
          data: dataMin,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        let datasetMax = new LineChartDataset({
          data: dataMax,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        let dataset = [datasetMin, datasetMax]

        return dataset

      },

      fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {

        let data = [], trendPointIndex = [], trendPoint = [], i = 0;
        let array = [];
        
        forEach(item, (point, index) => {

          if (point.isImportant) {
            trendPoint.push(
                array
            );
            array = [];
            trendPointIndex.push(index)
          } else {
            if (!point.isChanged) {
              array.push(point);
            }
            if (index == item.length - 1) {
              trendPoint.push(
                  array
              );
            }
          }

        });
        let dataset = [];

        if (trendLine) {
          forEach(trendPoint, (point) => {
            if (point.length > 2) {
              dataset.push(this.trendLine(point));
            }
          });
        }
        if (levelLine) {
          forEach(trendPoint, (point) => {
            if (point.length > 2) {
              dataset.push(this.levelLine(point));
            }
          });
        }
        if (scatterLine) {
          forEach(trendPoint, (point) => {
            if (point.length > 2) {
              dataset.push(this.scatterLine(point)[0]);
              dataset.push(this.scatterLine(point)[1]);
            }
          });
        }

        //this.isChangeStimuli = false;

        return dataset
      },

      goToGraph(graphId){
        let graph = 'mandGraphWrapp' + graphId;
        setTimeout(() => {
          if(this.$refs[graph]){
            this.$refs[graph][0].scrollIntoView({behavior: "smooth"});
          }
        }, 200);
      }
    },
    watch: {
      levelLineChecked(newValue) {
        this.isChangeStimuli = true;
        if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
          if (this.teachingMethod != 4) {
            this.trendLinePoint = this.fetchDatasetLineTrend(this.stimulRezults[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
          } else{
            forEach(this.chartDatasetsForStages, (dataSet, key) => {
              this.trendLineArrayPoint[key] = this.fetchDatasetLineTrend(dataSet.values, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
            });
          }
          
        } else {
          if (this.teachingMethod != 4) {
            this.trendLinePoint = null;
          } else{
            forEach(this.chartDatasetsForStages, (dataSet, key) => {
              this.trendLineArrayPoint[key] = null;
            });
          }
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);
      },
      trendLineChecked(newValue) {
        this.isChangeStimuli = true;
        if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
          if (this.teachingMethod != 4) {
            this.trendLinePoint = this.fetchDatasetLineTrend(this.stimulRezults[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
          } else{
            forEach(this.chartDatasetsForStages, (dataSet, key) => {
              this.trendLineArrayPoint[key] = this.fetchDatasetLineTrend(dataSet.values, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
            });
          }

        } else {
          if (this.teachingMethod != 4) {
            this.trendLinePoint = null;
          } else{
            forEach(this.chartDatasetsForStages, (dataSet, key) => {
              this.trendLineArrayPoint[key] = null;
            });
          }
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);

      },
      ScatterLineChecked(newValue) {
        this.isChangeStimuli = true;
        if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
          if (this.teachingMethod != 4) {
            this.trendLinePoint = this.fetchDatasetLineTrend(this.stimulRezults[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
          } else{
            forEach(this.chartDatasetsForStages, (dataSet, key) => {
              this.trendLineArrayPoint[key] = this.fetchDatasetLineTrend(dataSet.values, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
            });
          }

        } else {
          if (this.teachingMethod != 4) {
            this.trendLinePoint = null;
          } else{
            forEach(this.chartDatasetsForStages, (dataSet, key) => {
              this.trendLineArrayPoint[key] = null;
            });
          }
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);
      },
      levelLineCheckedImproved(newValue) {
        this.isChangeStimuli = true;
        if (this.trendLineCheckedImproved || this.levelLineCheckedImproved || this.ScatterLineCheckedImproved) {
          this.trendLinePointImproved = this.fetchDatasetLineTrend(this.stimulRezultsImproved[0].data, this.trendLineCheckedImproved, this.levelLineCheckedImproved, this.ScatterLineCheckedImproved);
        } else {
          this.trendLinePointImproved = null;
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);
      },
      trendLineCheckedImproved(newValue) {
        this.isChangeStimuli = true;
        if (this.trendLineCheckedImproved || this.levelLineCheckedImproved || this.ScatterLineCheckedImproved) {
          this.trendLinePointImproved = this.fetchDatasetLineTrend(this.stimulRezultsImproved[0].data, this.trendLineCheckedImproved, this.levelLineCheckedImproved, this.ScatterLineCheckedImproved);
        } else {
          this.trendLinePointImproved = null;
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);

      },
      ScatterLineCheckedImproved(newValue) {
        this.isChangeStimuli = true;
        if (this.trendLineCheckedImproved || this.levelLineCheckedImproved || this.ScatterLineCheckedImproved) {
          this.trendLinePointImproved = this.fetchDatasetLineTrend(this.stimulRezultsImproved[0].data, this.trendLineCheckedImproved, this.levelLineCheckedImproved, this.ScatterLineCheckedImproved);
        } else {
          this.trendLinePointImproved = null;
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);
      },
      mode(newValue) {
        if (newValue == 'detail') {
          this.applyFilter(this.changed);
          this.changed = false;
        }
      },
      rangeDateStart(newValue, oldValue) {
        this.showSimpleReport = false;
        if (!newValue) {
          this.rangeDateStart = oldValue;
        }
      },
      rangeDateEnd(newValue, oldValue) {
        this.showSimpleReport = false;
        if (!newValue) {
          this.rangeDateEnd = oldValue;
        } else{
          this.minDateStart =  this.getMinDateStart(newValue);
        }
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentStageResults.vue